<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
      <div class style="position: relative;margin-top: 30px;">
        <a-form :form="form" @submit="handleSubmit" style="width: 100%;">
          <a-form-item label="触发类型" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <a-select :change="typeChanged" v-model="info.type">
              <a-select-option :value="0">学分</a-select-option>
              <a-select-option :value="1">学时</a-select-option>
              <a-select-option :value="2">课程</a-select-option>
              <a-select-option :value="3" v-if="dataType==2">考试</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            label="课程学时"
            v-if="info.type==1"
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 21 }"
          >
            <a-input
              placeholder="请输入课程学时"
              v-decorator="[
          'value',
          {rules: [{ required: true, message: '请输入课程学时!' }],initialValue:info.value}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item
            label="课程学分"
            v-if="info.type==0"
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 21 }"
          >
            <a-input
              placeholder="请输入课程学分"
              v-decorator="[
                'value',
                {rules: [{ required: true, message: '请输入课程学分!' }],initialValue:info.value}
              ]"
            ></a-input>
          </a-form-item>
          <a-form-item
            label="关联课程"
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 21 }"
            v-if="info.type==2"
          >
            <a-select
              mode="multiple"
              placeholder="请选择课程"
              v-decorator="[
                'courseIds',
                    {rules: [{ required: true, message: '请选择课程!' }],initialValue:info.courseIds}
                ]"
              @change="targetChanged"
            >
              <a-select-option
                :value="info.id"
                v-for="(info, index) in courses"
                :key="index"
              >{{info.name}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            label="关联考试"
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 21 }"
            v-if="info.type==3"
          >
            <a-select
              mode="multiple"
              placeholder="请选择考试"
              v-decorator="[
                'examinationIds',
                    {rules: [{ required: true, message: '请选择考试!' }],initialValue:info.examinationIds}
                ]"
              @change="targetChanged"
            >
              <a-select-option
                :value="info.id"
                v-for="(info, index) in examinations"
                :key="index"
              >{{info.testName}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 21, offset: 3 }">
            <pxkeji-btn name="保存" type="primary" htmlType="submit" />
          </a-form-item>
        </a-form>
      </div>
    </div>
  </a-spin>
</template>

<script>
var that;
export default {
  props: {
    id: String,
    dataType: Number,
    projectId: String,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      info: {
        type: 0,
        courseIds: [],
        examinationIds: [],
      },
      courses: [],
      examinations: [],
      isloading: false,
      loadingTip: "加载中...",
    };
  },
  mounted() {
    this.$nextTick(function () {
      that = this;
      this.getTrigger();
    });
  },
  methods: {
    sumbit() {
      this.$emit("callbackMethod");
    },
    typeChanged(v) {
      if (v == 2 || v == 3) {
        this.info.targetIds = [];
      }
    },
    targetChanged(value) {
      this.info.targetIds = value;
    },
    getTrigger() {
      this.$api.project
        .getTrigger(this.projectId, this.id, this.dataType)
        .then((res) => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            if (res.data.trigger) {
              this.info = res.data.trigger;
              this.info.courseIds = [];
              this.info.examinationIds = [];
              this.info.targetIds = this.info.targetIds
                ? this.info.targetIds
                : [];
              if (this.info.type == 2) {
                this.info.courseIds = this.info.targetIds;
              } else if (this.info.type == 3) {
                this.info.examinationIds = this.info.targetIds;
              }
            }

            this.courses = res.data.courses;
            this.examinations = res.data.examinations;
          } else {
            this.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.isloading = true;

          this.$api.project
            .setTrigger(
              this.projectId,
              this.id,
              this.dataType,
              this.info.type,
              values.value,
              this.info.targetIds ? this.info.targetIds.join(",") : ""
            )
            .then((res) => {
              this.isloading = false;
              if (res.errorCode == this.$msg.responseCode.success) {
                this.$message.success(res.errorMsg);
                this.$emit("callbackMethod", true);
              } else {
                this.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              this.isloading = false;
            });
        }
      });
    },

    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        },
      });
    },
  },
};
</script>
<style>
</style>